<script setup>
import { computed, ref } from "vue";
import iphoneModels from "../utils/iphoneModels.js";

const OTHER_IPHONE_KEY = "other_iphone";

const props = defineProps({
  open: { type: Boolean, default: false },
  cameras: { type: Array, default: () => [] }
});

const emit = defineEmits(["select", "close"]);

const selectedItem = ref(null);

const items = computed(() => {
  let list;
  if (props.cameras.length > 3) {
    list = iphoneModels.proModels;
  } else if (props.cameras.length > 1 && props.cameras.length <= 3) {
    list = [...iphoneModels.nonProMultiCamera, { model: OTHER_IPHONE_KEY }];
  } else {
    list = [...iphoneModels.singleCamera, { model: OTHER_IPHONE_KEY }];
  }
  return list;
});

const close = (skip) => {
  emit("close", skip);
};
const selectItem = (item) => {
  selectedItem.value = item;
};

const confirmSelection = () => {
  if (!selectedItem.value) return;
  if (selectedItem.value.model === OTHER_IPHONE_KEY) {
    window.location.href = `${window.location.origin}/${import.meta.env.VITE_PHOTO_AUTH_PREFIX}${window.location.search}`;
  } else {
    if (window.localStorage.getItem("iphoneModel") !== selectedItem.value.model) {
      window.localStorage.setItem("iphoneModel", selectedItem.value.model);
    }
    emit("select");
  }
  close();
};
</script>

<template>
<transition name="slide-up">
  <div v-if="open" class="fixed bottom-0 left-0 right-0 bg-black/25 z-[99999]" @click.self="close">
    <div class="bg-white shadow-[0_-1px_10px_0_rgba(0,0,0,0.25)] flex flex-col gap-4 px-4.5 py-3 max-h-[95dvh]" role="dialog" aria-modal="true">
      <div class="text-[18px] font-bold text-[#222222] text-center mt-[15px]">
        {{ $t("iphone_models.title") }}
      </div>
      <div class="text-[14px]">
        {{ $t("iphone_models.description") }}
      </div>
      <ul class="p-0 m-0 text-center overflow-y-auto overflow-x-hidden w-full flex justify-center flex-col">
        <li v-for="item in items" :key="item.model" :class="['cursor-pointer text-[var(--secondary)] text-center px-2.5 py-1.5', { 'bg-[color-mix(in_srgb,var(--secondary)_20%,transparent)]': selectedItem && selectedItem.model === item.model }]" @click="selectItem(item)">
          <div class="relative text-center w-full">
            <div :class="['text-[17px] text-center w-full', selectedItem && selectedItem.model === item.model ? 'font-bold' : 'font-normal']">
              {{ item.model === OTHER_IPHONE_KEY ? $t("iphone_models.other") : item.model }}
            </div>
            <div v-if="selectedItem && selectedItem.model === item.model" class="absolute right-0 top-0 bottom-0 -translate-x-1/2">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
                <g clip-path="url(#clip0_1012_1937)">
                  <path d="M9.50016 16.1701L5.33016 12.0001L3.91016 13.4101L9.50016 19.0001L21.5002 7.00009L20.0902 5.59009L9.50016 16.1701Z" fill="currentColor" class="fill-[var(--secondary)]" />
                </g>
                <defs>
                  <clipPath id="clip0_1012_1937">
                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </li>
      </ul>
      <button class="mx-auto block p-2.5 bg-black text-white border-none rounded-sm text-[18px] font-bold disabled:bg-[#999]" :disabled="!selectedItem" @click="confirmSelection">
        {{ $t("iphone_models.continue") }}
      </button>
      <button class="bg-transparent border-none text-sm leading-none cursor-pointer text-center text-[var(--secondary)] font-normal py-1.5 px-2.5" aria-label="Close" @click="close(true)">
        {{ $t("iphone_models.skipModel") }}
      </button>
    </div>
  </div>
</transition>
</template>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition:
    transform 220ms ease,
    opacity 220ms ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(16px);
  opacity: 0;
}
</style>
